export default __webpack_public_path__ + "static/media/bl19.25b50d1e.png";